import React, { FC, useCallback, useEffect, useState, useContext } from 'react';
import { TasksContext, TasksDispatchContext, TasksProvider, useTask } from '../stateManagement/context';

import { get, post } from "../fetchers/fetchers";

import { useParams } from "react-router";

import {
    Accordion,
    AccordionSummary,
    Chip,
    Grid, MenuItem,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Tooltip,
    Typography
} from "@material-ui/core";
import {
    AdequacyTypeID,
    IAdequacy,
    IAssessmentSettings,
    IControlMeasure,
    IControlMeasureAdequacy,
    IControlMeasureAssessment,
    IControlMeasureCost,
    IControlMeasureFailureMode,
    IControlType,
    ICriticalHazards,
    IFailureModeAssessment,
    IHarm,
    IProjectFailureMode
} from "../types/types";
import { ExpandMore } from "@material-ui/icons";
import WarningIcon from '@material-ui/icons/Warning';
import { Consequence } from "./harm";
import { Confidence } from "./critical_failure_mode";
import { ControlAssessment } from "./control_measure_adequacy";
import ReasonablyPracticableTest from "./reasonably_practicable_test";
import ReasonablyPracticableSummary from "./reasonably_practicable_summary";
import { API_URL } from "../env";


interface IControlMeasureAssessmentsProps {
    existing: boolean
}

interface IRouteParams {
    id: string
}



export const WarningChip = (name: string) => {

    let color = "#535353"
    let bcolor = "rgb(196,196,196)";

    return (
        <div>
            <Tooltip title="Not enough data for assessment">
                <Chip
                    icon={<WarningIcon />}
                    size="small"
                    label={name}
                    color="primary"
                    style={{ backgroundColor: bcolor, color: color }}
                />
            </Tooltip>
        </div>
    )
}


const SummaryReasonablyPracticable: FC<IControlMeasureAssessmentsProps> = ({ existing }) => {

    let dispatch = useContext(TasksDispatchContext)
    let tasks = useTask()

    const [isLoaded, setIsLoaded] = useState<boolean>(true);
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [controlTypes, setControlTypes] = useState<IControlType[]>([]);
    const [controlMeasures, setControlMeasures] = useState<IControlMeasure[]>([]);
    const [adequacies, setAdequacies] = useState<IAdequacy[]>([]);
    const [failureModes, setFailureModes] = useState<IProjectFailureMode[]>([]);
    const [controlMeasureAssessments, setControlMeasureAssessments] = useState<IControlMeasureAssessment[]>([]);
    const [controlMeasureFailureModes, setControlMeasureFailureModes] = useState<IControlMeasureFailureMode[]>([]);
    const [harms, setHarms] = useState<IHarm[]>([]);
    const [riskAssessments, setRiskAssessments] = useState<ICriticalHazards[]>([]);
    const [controlMeasureAdequacies, setControlMeasureAdequacies] = useState<IControlMeasureAdequacy[]>([]);
    const [controlMeasureCosts, setControlMeasureCosts] = useState<IControlMeasureCost[]>([]);
    const [reloadControlMeasures, setReloadControlMeasures] = useState<boolean>(false);
    const [failureModeAssessments, setFailureModeAssessments] = useState<IFailureModeAssessment[]>([]);
    const [assessmentSettings, setAssessmentSettings] = useState<IAssessmentSettings>();
    useEffect(() => {

        if (tasks.loaded) {

            setControlMeasures(tasks.controlMeasures)
            setFailureModes(tasks.failureModes)
            setControlMeasureFailureModes(tasks.failureModeControlMeasures)
            setFailureModeAssessments(tasks.failureModeAssessments)
            setAdequacies(tasks.adequacies)
            setControlTypes(tasks.controlTypes)
            setControlMeasureAssessments(tasks.controlMeasureAssessments)
            setControlMeasureCosts(tasks.controlMeasureCosts)
            setControlMeasureAdequacies(tasks.controlMeasureAdequacy)
            setRiskAssessments(tasks.criticalHazards)
            setHarms(tasks.harms)
            setAssessmentSettings(tasks.assessmentSettings)

        }

    },[tasks])

    
    const params = useParams<IRouteParams>()

    const setControlMeasureAssessment = async (controlMeasureAssessment: IControlMeasureAssessment) => {
        delete controlMeasureAssessment.id
        return await post<IControlMeasureAssessment>(API_URL + "control_measures/" + params.id.toString() + "/assessments", controlMeasureAssessment);
    }


    const updateControlMeasureAssessmentFinal = useCallback((controlMeasureAssessment: IControlMeasureAssessment) => {
        setReloadControlMeasures(true);
        setControlMeasureAssessment(controlMeasureAssessment).then(() => {
            setReloadControlMeasures(true);
        })
    }, [setControlMeasureAssessment, setReloadControlMeasures]);

 

    const getCMeasureCost = (cm: IControlMeasure): IControlMeasureCost => {
        let cm_id = cm.uuid
        if (!cm_id)
            cm_id = -1
        let controlMeasureCost = controlMeasureCosts.find(cma => cma.control_measure_id === cm_id)

        if (controlMeasureCost) {
            return controlMeasureCost
        }
        controlMeasureCost = {
            control_measure_id: cm_id
        }
        return controlMeasureCost
    }

    const overall_asessment = ["Reasonably Practicable",
        "Reasonably Practicable (tentative)",
        "Not Reasonably Practicable (tentative)",
        "Not Reasonably Practicable",
        "Cannot Determine at this Time"
    ]


    const getCMeasureAssessments = (cm: IControlMeasure): IControlMeasureAssessment[] => {

        let cm_id = cm.uuid
        if (!cm_id)
            cm_id = -1
        return controlMeasureAssessments.filter(cma => cma.control_measure_id === cm_id)

    }

    const [expanded, setExpanded] = React.useState<string | false>(false);

    const handleChange = (panel: string) => (event: React.ChangeEvent<{}>, isExpanded: boolean) => {
        setExpanded(isExpanded ? panel : false);
    };

    const render_category = (index: number, a: string) => {

        return (
            <Accordion style={{ backgroundColor: "#f3f3f3" }} expanded={expanded === 'panel' + index} onChange={handleChange('panel' + index)} square>
                <AccordionSummary id={index.toString()} expandIcon={<ExpandMore />}>

                    <Typography variant="h6"> {a} </Typography>
                </AccordionSummary>

                <Table stickyHeader={true} style={{ backgroundColor: "#FFFFFF" }}>
                    <TableHead>
                        <TableCell><b>Control Measures</b></TableCell>
                        <TableCell>Type</TableCell>
                        <TableCell width={30}>Good Practice </TableCell>
                        <TableCell>Order of magnitude of Costs ($M)</TableCell>
                        <TableCell width={60}>Justification Based in Disproportion Ratio</TableCell>
                        <TableCell width={30}>De Minimis</TableCell>
                        <TableCell>Failure Modes Addressed</TableCell>
                        <TableCell>Justification</TableCell>
                        <TableCell>Comments</TableCell>
                    </TableHead>

                    {render_control_measure_assessment(index)}
                </Table>
                <div>
                    {/* <Typography><small>Note only included or de minimis control measures are shown; *Failure Mode used for justification</small></Typography> */}
                    <Typography><small>* Failure Mode used for justification</small></Typography>
                </div>
            </Accordion>

        )
    }

    const get_failure_modes = (control_measure: IControlMeasure, filter?:number) => {

        let cmas = getCMeasureAssessments(control_measure)
        let projectFailureModes: IProjectFailureMode[] = []

        cmas.map((cma) => {

            let f = controlMeasureFailureModes.find(
                cmf => cmf.control_measure_id === cma.control_measure_id && cmf.priority > 0 
                && cma.project_failure_mode_id === cmf.project_failure_mode_id
            )

            if (f) {
                let fm = failureModes.find(fm => fm.id === f?.project_failure_mode_id)

                if (fm) {
                   
                    if ( filter !== undefined) {
                        if ( filter !== -1) {
                            if( f.priority !== filter ) {
                                return
                        }
                    }
                    }
                    
                    if (fm.failure_mode?.is_active) {
                        projectFailureModes.push(fm)
                    }
                }
            }
            
        })

        return projectFailureModes

    }



    const render_control_measure_assessment = (index: number) => {

        // for each control measure
        return controlMeasures.filter((c) => c.existing === existing)
            .map((cm) => {
                // console.log(cm.description, "cm", cm )

                if (!cm) {
                    return <></>
                }
                let cmas = getCMeasureAssessments(cm)
                let projectFailureModes: IProjectFailureMode[] = []

                let considered = false
                let de_minimis = false

                let filtered_control_measures_assessments = cmas.filter(cma => (cma.overall_assessment_id === index))

   
                // multiple assessment per cma are possible. eg coming from the priority and additional failure modes
                filtered_control_measures_assessments.map((cma) => {
                    console.log(cm.description, "cma", cma)
                    // find the failure modes that are included in the control measure assessment with priority > 0
                    let f = controlMeasureFailureModes.find(
                        cmf => cmf.control_measure_id === cma.control_measure_id && 
                        cmf.priority > 0 && 
                        (cma.project_failure_mode_id === cmf.project_failure_mode_id )
                    )

                    if (f) {
                        let fm = failureModes.find(fm => fm.id === f?.project_failure_mode_id)
                        if (fm) {
                             if (!projectFailureModes.find( pf => pf.id === fm?.id)) {
                                projectFailureModes.push(fm)
                            }
                        }
                    }
                    
                    // find linked priority failure mode with project_failure_mode_id === -1 if is_failure_mode_centric is true
                    if (assessmentSettings?.is_failure_mode_centric && cma.project_failure_mode_id === -1) {
                        get_failure_modes(cm).map( fm => {
                            if (!projectFailureModes.find( pf => pf.id === fm.id)) {
                                projectFailureModes.push(fm)
                            }
                        })
                    }

                    if (cma.considered) {
                        considered = true
                    }
                    if (cma.de_minimis) {
                        de_minimis = true
                    }   

                })

                console.log(cm.description, "projectFailureModes", projectFailureModes, index)
                
                if (projectFailureModes.length === 0){
                    return <></>
                }    
                
                considered = true
                

                if (!considered && !de_minimis) {
                    return <></>
                }

                return (
                    <ReasonablyPracticableSummary control_types={controlTypes}
                        comment_id={index}
                        control_measure={cm}
                        project_failure_modes={projectFailureModes}
                        failure_mode_assessments={failureModeAssessments}
                        control_measure_assessments={filtered_control_measures_assessments}
                        control_measure_cost={getCMeasureCost(cm)}
                        updateControlMeasures={updateControlMeasureAssessmentFinal}
                        adequacies={adequacies}
                        risk_assessments={riskAssessments}
                        is_failure_mode_centric={assessmentSettings?.is_failure_mode_centric || false}
                    />
                )

            })
    }

    return (

        
        
        <Grid container xs={12} lg={12} style={{ padding: 10, width: "100%" }}>
            <Paper variant={"outlined"}
            
                style={{ display: "flex", flexDirection: "column", height: "100%", margin: "10px", flex: 1 }}>
                {isLoaded && overall_asessment.map((a, index) => {
                    return render_category(index + 1, a)

                })}
                {/* <div>
                    <Typography><small>Note only included group failure modes are shown</small></Typography>
                </div> */}
            </Paper>
        </Grid>


    );
}

export default SummaryReasonablyPracticable;

